import React, { useState, useEffect, useContext } from "react"
import { Link, NavLink, useNavigate } from 'react-router-dom';
import MonthPickerComponent from '../../Utils/MonthPickerComponent'
import { TableDownloadContext } from '../../Contexts/TableDownloadContext'
import moment from "moment"
import line from "../../images/line.png"
import xls from "../../images/xls/png/Group 47.png"
import FileIcon from "../../images/file.png"
import FileIconBlur from "../../images/fileblur.png"
import ExcelPopup from "../../Components/ExcelPopup";
import '../MainMenu.css'
import { useLocation } from "react-router-dom";
import { routeNames } from "../../routeSegments";
import Switch from '../../Components/CFS/DetailsPage/CFSFinancial/ToggleSwitch'
import ToggleButton from "../RefineSearchComponents/ToggleSwitch";

import ExportPopup from "../../Components/ExportPopup/FundsExcel";
import { data, limitedPartnerProfileExportData, limitedPartnerexitExportData } from "../../Components/ExportPopup/ExportData"
import { iocExcelExport, exportLPExcel } from "../../Config/config";
import { TableDataContext } from '../../Contexts/TableDataContext'
import PdfDownloader from "../shared/PdfDownloader";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import Constants from "../../Constants";
import { UserContext } from "../../Contexts/UserContext";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import ExcelDownloader from "../shared/ExcelDownloader";
import { Tooltip } from "antd";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../ExportPopup/DownloadTrigger";

/**
 * The MainMenu function is a React component that renders a menu with various options and buttons,
 * including a switch for currency, a download button for exporting data to Excel, and a button for
 * downloading PDF files.
 * @param props - An object containing the properties passed to the MainMenu component.
 * @returns The MainMenu component is returning a JSX element.
 */
function MainMenu(props) {
    const { handleDownloadExcel } = useContext(TableDownloadContext)
    const {totalNoOfCompanies, setTotalNoOfCompanies,tableCompanyId,currency, setCurrency, globalSearchResult, data } = useContext(TableDataContext);
    const { monthPickerValue, refineSearchFilters,groupId, isMobile,setOpen,open,setIsMobile,iocPayload } = useContext(PeFilterContext);

    console.log(data,"khkh")
    
    const [openTab, setOpenTab] = React.useState(1);
    const [showPopup, setShowPopup] = useState(false);
    const [date, setDate] = useState([
        moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD"),
      ]);
    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])

    const {isStudent} = useContext(UserContext)
    const { pathname } = useLocation();
    const download = () => {
        handleDownloadExcel()
    }
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const handleToggle = (isOn) => {
        setCurrency(isOn=='and' ? 'USD' :'INR')
      };
      useEffect(()=>{
        if (window.innerWidth < 800) {
            // setOpen(true);
            setIsMobile(true);
        }    },[])
    return (
        <div className="pt-0 pl-3 md:pr-4 pr-3">
            <div className="scrollbar rounded">
                <div className="py-2 px-5 items-center rounded-b-none bg-[#FFFFFF] block lg:flex flex-row justify-between shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                    {props.menu === "cfs" || props.menu === "ioc" ? (
                        <div className="flex flex-row space-x-5">
                            <div className="text-[14pt] lg:text-[16px] leading-[14px] font-sans_book_body text-[#666666]">
                                Total no. of companies: {isFromGlobalSearch() ? globalSearchResult?.cfs_company?.length : totalNoOfCompanies}
                            </div>
                        </div>
                    ) : null}

                    <div className="flex justify-between py-2 lg:py-0 space-x-2 items-center">
                        {props.menu !== "ioc" && (
                            <div className="pt-[.5rem] md:pt-0 lg:pt-0">
                                <Switch />
                                {/* <ToggleButton onLabel="USD" offLabel="INR" onToggle={handleToggle} /> */}
                            </div>
                        )}
                        
                        <div className="flex justify-between items-center space-x-2">
                                    {/* <button
                                        className="cursor-pointer lg:ml-7 ml-4 mt-2"
                                        onClick={() => setOpen(!open)}
                                    >
                                        <FaFilter color="#bc8b20" size={21} />
                                    </button> */}
                                    <a>
                                        <img
                                            className="h-[24px] max-w-[2px] mt-2"
                                            src={line}
                                            alt="Separator"
                                        />
                                    </a>
                            <span>
                                {isStudent === 'true' || groupId?.myList?.length > 0 ? null : (
                                <ExcelDownloader fileName={Constants.exportNames.ioc_list} 
                                data={{
                                        "inv_deal_columns": [
                                            "ALL"
                                        ],
                                        "charges":iocPayload.company?.length ||
                                            iocPayload.charge_holder_name?.length ||
                                            iocPayload.charge_date ||
                                            iocPayload.charge_amount ||
                                            iocPayload.state?.length ||
                                            iocPayload.city?.length
                                                ? {
                                                company: iocPayload.company?.map(company => company.id),
                                                charge_holder_name: iocPayload.charge_holder_name?.map(holder => parseInt(holder.id, 10)),
                                                charge_date: iocPayload.charge_date,
                                                charge_amount: iocPayload.charge_amount,
                                                state: iocPayload.state?.map(item => item.id) || [],
                                                city: iocPayload.city?.map(item => item.id) || [],
                                                order_by: {
                                                    column: "company",
                                                    direction: "asc",
                                                },
                                                }
                                        : {},
                                        "is_detail_page" : false
                                    }} url={iocExcelExport} >

                                        <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />

                                    </ExcelDownloader>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainMenu